module.exports = __webpack_public_path__ + "static/Dhedge-cb85efa5282efe6d5bda3ab7bf8af1fe.png";